import type { JSX } from "react";
// copy right text
type copy_right_text_type = {
  copy_right: JSX.Element;
};

const copy_right_text: copy_right_text_type = {
  copy_right: (
    <>© {new Date().getFullYear()} MUSE Content, All Rights Reserved </>
  ),
};

const { copy_right } = copy_right_text;
export const CopyRight = () => {
  return <> {copy_right}</>;
};
